import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Button, Space, Modal } from 'antd';
import { AugmentedReality } from 'tabler-icons-react';

import { simpleDateFormatter } from '../../../../../../utils/dateFormatter';

export const useErrorsListColumns = errors => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const dateFilter = Array.from(new Set(errors.map(error => error.date)));
  const payerFilter = Array.from(new Set(errors.map(error => error.payer)));
  const receiverFilter = Array.from(new Set(errors.map(error => error.receiver)));
  const receiverCountryFilter = Array.from(new Set(errors.map(error => error.receiver_country)));
  const senderCountryFilter = Array.from(new Set(errors.map(error => error.sender_country)));
  const typeFilter = Array.from(new Set(errors.map(error => error.type)));
  const sorterFilter = Array.from(new Set(errors.map(error => error.sorter)));

  const close = () => {
    setOpen(false);
  };

  return [
    {
      key: 'filename',
      dataIndex: 'filename',
      title: t('myCompanies.filename'),
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: t('myCompanies.type'),
      sorter: (a, b) => a.type.localeCompare(b.type),
      filters: typeFilter.map(filter => ({ text: filter, value: filter })),
      onFilter: (value, record) => record.type === value,
    },
    {
      key: 'sorter',
      dataIndex: 'sorter',
      title: t('myCompanies.sorter'),
      sorter: (a, b) => a.sorter.localeCompare(b.sorter),
      filters: sorterFilter.map(filter => ({ text: filter, value: filter })),
      onFilter: (value, record) => record.sorter === value,
    },
    {
      key: 'payer',
      dataIndex: 'payer',
      title: t('myCompanies.payer'),
      sorter: (a, b) => a.payer - b.payer,
      filters: payerFilter.map(filter => ({ text: filter, value: filter })),
      onFilter: (value, record) => record.payer === value,
    },
    {
      key: 'sender_country',
      dataIndex: 'sender_country',
      title: t('myCompanies.sender_country'),
      sorter: (a, b) => a.sender_country.localeCompare(b.sender_country),
      filters: senderCountryFilter.map(filter => ({ text: filter, value: filter })),
      onFilter: (value, record) => record.sender_country === value,
    },
    {
      key: 'receiver',
      dataIndex: 'receiver',
      title: t('myCompanies.receiver'),
      sorter: (a, b) => a.receiver - b.receiver,
      filters: receiverFilter.map(filter => ({ text: filter, value: filter })),
      onFilter: (value, record) => record.receiver === value,
    },
    {
      key: 'receiver_country',
      dataIndex: 'receiver_country',
      title: t('myCompanies.receiver_country'),
      sorter: (a, b) => a.receiver_country.localeCompare(b.receiver_country),
      filters: receiverCountryFilter.map(filter => ({ text: filter, value: filter })),
      onFilter: (value, record) => record.receiver_country === value,
    },
    {
      key: 'date',
      dataIndex: 'date',
      title: t('myCompanies.date'),
      sorter: (a, b) => a.date.localeCompare(b.date),
      filters: dateFilter.map(filter => ({ text: simpleDateFormatter(filter), value: filter })),
      onFilter: (value, record) => record.date === value,
      render: text => simpleDateFormatter(text),
    },
    {
      key: 'action',
      dataIndex: 'xml',
      title: t('myCompanies.action'),
      render: (xml, record) => {
        let url = process.env.REACT_APP_API_URL + 'wco-xml/' + record.filename;
        return (
          <Space size={2}>
            <Button type='link' onClick={() => setOpen(true)}>
              <AugmentedReality />
            </Button>
            <Modal
              title='WCOXML file'
              centered
              open={open}
              width={1000}
              onCancel={close}
              onOK={close}
              footer={[
                <Button key='link' href={url}>
                  Pobierz
                </Button>,
                <Button key='back' onClick={close} type='primary'>
                  Zamknij
                </Button>,
              ]}
            >
              <p>{xml}</p>
            </Modal>
          </Space>
        );
      },
    },
  ];
};
